import { OPTION_ACCOUNT_CANCELLATION_ACCOUNT, OPTION_ACCOUNT_TRANSFER_ACCOUNT_FROM_OTHER_BANK } from "constants/accounts";

export const ACTION_BUTTON_TRANSFER_FLOW = 'TRANSFERFLOW'
export const ACTION_BUTTON_FIOC_FLOW = 'FIOCFLOW'
export const ACTION_BUTTON_DNI_FLOW = 'DNIFLOW'

export const REDIRECT_TO_TRANSFER_URL = '/myprofile/transfers';
export const REDIRECT_TO_FIOC_URL = '/myprofile/fioc';
export const REDIRECT_TO_DNI_URL = '/myprofile/documentation/uploadDocumentation';

export const ACTION_BUTTON_FLOWS = {
    [ACTION_BUTTON_TRANSFER_FLOW]: REDIRECT_TO_TRANSFER_URL,
    [ACTION_BUTTON_FIOC_FLOW]: REDIRECT_TO_FIOC_URL,
    [ACTION_BUTTON_DNI_FLOW]: REDIRECT_TO_DNI_URL,
}

// Modal
export const MODAL_STATIC_CONTENT = {
    [OPTION_ACCOUNT_CANCELLATION_ACCOUNT]: {
        errorTitle: 'cancellation_account-cancellation_account_error_modal_title',
        errorDescription: 'cancellation_account-cancellation_account_error_modal_description',
        errorPrimaryButtonText: 'cancellation_account-cancellation_account_error_modal_retry_button',
        cancelButtonText: 'cancellation_account-cancel',
    },
    [OPTION_ACCOUNT_TRANSFER_ACCOUNT_FROM_OTHER_BANK]: {
        errorTitle: 'transfer_account-transfer_account_from_another_bank_error_modal_title',
        errorDescription: 'transfer_account-transfer_account_from_another_bank_error_modal_subtitle',
        errorPrimaryButtonText: 'transfer_account-transfer_account_from_another_bank_error_modal_accept_button',
        cancelButtonText: 'common-cancel',
    }
}

